export const getValueBySource = (location, currentSource) => {
  if (currentSource === 'all') {
    return location.value
  }

  const source = location.details.filter(source => source.source === currentSource)

  if (source.length) {
    return source[0].value
  }

  return -1
}

export const isInActiveFilters = (currentValue, activeFilters, filters) => {
  const f = filters.filter(filter => activeFilters.includes(filter.key))
  return f.some(filter => currentValue >= filter.min && currentValue <= filter.max)
}

export const copyToClipboard = str => {
  const el = document.createElement('textarea')
  el.value = str
  el.setAttribute('readonly', '')
  el.style.position = 'absolute'
  el.style.left = '-9999px'
  document.body.appendChild(el)
  el.select()
  document.execCommand('copy')
  document.body.removeChild(el)
}
